import React from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";

const LandingPage = () => {
  return (
    <div>
      <Navbar />
      <Hero />
    </div>
  );
};

export default LandingPage;
